<template>
  <div>
    <LdSkeleton shape="image" b="4px solid transparent" class="aspect-ratio-1 w-full" />
    <div class="mt-8px h-36px">
      <LdSkeleton class="w-50%" />
    </div>
  </div>
</template>
